// extracted by mini-css-extract-plugin
export default {"table":"KeyValueTable_table__Y7+E9","row":"KeyValueTable_row__C33c8","keyColumn":"KeyValueTable_keyColumn__9z-bY","valueColumn":"KeyValueTable_valueColumn__hEShA"};